import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[inputAutoFocus]'
})
export class AutoFocusDirective implements OnInit {
    constructor(private elementRef: ElementRef) {
    }

    ngOnInit() {
        this.elementRef.nativeElement.focus();
        // console.log( this.elementRef.nativeElement.value );
        // this.elementRef.nativeElement.min = 0;
        // this.elementRef.nativeElement.type = "number";
        // this.elementRef.nativeElement.value = '';
    }
}
